@if (speechService.isSupported()) {
  <app-custom-button
    (buttonClick)="toggleListening()"
    [icon]="speechService.isListening ? 'mic' : 'mic_none'"
    [tooltip]="speechService.isListening ? 'Stop listening' : 'Start voice input'"
    [active]="speechService.isListening"
    variant="filled"
  ></app-custom-button>
}
